"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectEntitlementExportPdf = exports.selectEntitlements = void 0;
var tslib_1 = require("tslib");
// (C) 2023 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.entitlements; });
/**
 * Returns dashboard's entitlements.
 *
 * @remarks
 * It is expected that the selector is called only after the entitlements state
 * is correctly initialized. Invocations before initialization lead to invariant errors.
 *
 * @alpha
 */
exports.selectEntitlements = toolkit_1.createSelector(selectSelf, function (state) {
    ts_invariant_1.default(state.entitlements, "attempting to access uninitialized entitlements state");
    return state.entitlements;
});
/**
 * @alpha
 */
exports.selectEntitlementExportPdf = toolkit_1.createSelector(exports.selectEntitlements, function (entitlements) {
    return entitlements.find(function (entitlement) { return entitlement.name === "PdfExports"; });
});
//# sourceMappingURL=entitlementsSelectors.js.map